import React from 'react';
import HoishTatvarTailan from './hm02_9';

const PageList = () => <HoishTatvarTailan />;

export default PageList;
